import { css } from 'lit';

export const IxPricingStyles = css`
  :host {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  td,
  th {
    text-align: center;
    vertical-align: top;
    padding: 0.2rem 0 0.25rem;
  }

  td:first-child,
  th:first-child {
    text-align: left;
    width: 50%;
  }

  tr:nth-last-child(2) td {
    padding-top: 2rem;
  }
`;
